import React, { useState } from "react";
import { Link } from "react-router-dom";
import Header from "./Header";
import vegas from "../vegas.jpg";
import team from "../assets/team.jpg";
import ConciergeSignal from "../assets/signal2.jpg";
import "@fontsource/oswald";

const Home = () => {
    const [guideCheckoutStatus, setGuideCheckoutStatus] = useState("idle");
    const [guideCheckoutError, setGuideCheckoutError] = useState("");
    const [showGuidePromo, setShowGuidePromo] = useState(false);
    const [guidePromoCode, setGuidePromoCode] = useState("");
    const [guidePromoStatus, setGuidePromoStatus] = useState("idle");
    const [guidePromoMessage, setGuidePromoMessage] = useState("");

    const startGuideCheckout = async (promoCode = null, rethrowError = false) => {
        const endpoint =
            process.env.REACT_APP_GUIDE_CHECKOUT_ENDPOINT ||
            "https://l7qmpdzu54.execute-api.us-west-1.amazonaws.com/prod/guideEmail";
        const productId = "prod_VL57uN1OHrSyZx";

        setGuideCheckoutStatus("loading");
        setGuideCheckoutError("");

        try {
            const response = await fetch(endpoint, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    productId,
                    productType: "vegas_guide",
                    customAmount: 14.99,
                    originalPrice: 14.99,
                    promoCode,
                    successUrl: `${window.location.origin}/?guide_purchase=success`,
                    cancelUrl: `${window.location.origin}/?guide_purchase=canceled`,
                }),
            });

            const data = await response.json().catch(() => ({}));
            if (!response.ok) {
                throw new Error(data.message || "Failed to start checkout.");
            }
            if (!data?.url) {
                throw new Error("Checkout session did not return a redirect URL.");
            }

            window.location.assign(data.url);
        } catch (error) {
            console.error("Guide checkout error", error);
            setGuideCheckoutStatus("error");
            setGuideCheckoutError(
                "We couldn't start checkout. Please try again or contact info@jackpotconcierge.com."
            );
            if (rethrowError) throw error;
        }
    };

    const updateGuidePromoCode = (event) => {
        setGuidePromoCode(event.target.value.toUpperCase().replace(/[^A-Z0-9_-]/g, "").slice(0, 20));
        setGuidePromoStatus("idle");
        setGuidePromoMessage("");
    };

    const applyGuidePromoCode = async () => {
        const promoCode = guidePromoCode.trim().toUpperCase();
        if (!promoCode) {
            setGuidePromoStatus("error");
            setGuidePromoMessage("Please enter a promo code.");
            return;
        }

        setGuidePromoStatus("checking");
        setGuidePromoMessage("");
        try {
            setGuidePromoMessage("Applying promo code...");
            await startGuideCheckout(promoCode, true);
        } catch (error) {
            setGuidePromoStatus("error");
            setGuidePromoMessage(error.message || "Failed to apply promo code.");
        }
    };

    return (
        <div
            className="min-h-screen bg-cover bg-center flex flex-col text-white"
            style={{
                backgroundImage: `url(${vegas})`,
            }}
        >
            <div className="bg-black bg-opacity-80 min-h-screen">
                <Header />

                <div className="animate-fade-in">
                    <div className="flex justify-center items-center p-6">
                        <main className="relative bg-white bg-opacity-10 text-white rounded-lg shadow-xl max-w-7xl w-full px-6 py-10 text-center">
                            <h1
                                className="text-5xl font-bold text-[#b42520] tracking-tight"
                                style={{
                                    fontFamily:
                                        "'Oswald'",
                                    fontSize:
                                        "60px",
                                    fontWeight:
                                        "bold",
                                    color:
                                        "#b42520",
                                }}
                            >
                                Jackpot Concierge
                            </h1>

                            <div className="mt-10">
                                <img
                                    src={
                                        team
                                    }
                                    alt="Roulette Celebration"
                                    className="w-full max-w-3xl mx-auto rounded-lg border border-white"
                                />
                            </div>

                            <div
                                className="relative z-10"
                                style={{
                                    fontFamily:
                                        "'oswald', sans-serif",
                                }}
                            >
                                <p className="mt-6 text-xl font-semibold">
                                    Voted Las Vegas' #1 independent luxury travel agent and concierge provider!
                                </p>

                                <div className="mt-6 grid grid-cols-1 lg:grid-cols-3 gap-4 text-left">
                                    <div
                                        className="flex h-full flex-col rounded-xl bg-white/10 border border-white/20 p-5 shadow-md transition
                                                   hover:border-[#b42520] hover:bg-white/15 hover:shadow-xl"
                                        aria-label="Buy the Jackpot Concierge Vegas Guide"
                                    >
                                        <div className="text-sm font-extrabold text-[#ff3b30]">
                                            SELF-GUIDED
                                        </div>

                                        <div className="mt-2 text-2xl font-extrabold lg:min-h-[4.5rem]">
                                            Want the inside scoop on Vegas?
                                        </div>

                                        <div className="mt-4 flex flex-col items-center">
                                            <button
                                                type="button"
                                                onClick={() => startGuideCheckout()}
                                                disabled={guideCheckoutStatus === "loading"}
                                                className="inline-flex min-h-[52px] w-full items-center justify-center rounded-lg bg-[#b42520] px-5 py-3 text-lg font-extrabold text-white transition hover:bg-[#941c18] disabled:cursor-wait disabled:opacity-70"
                                            >
                                                {guideCheckoutStatus === "loading"
                                                    ? "Opening Checkout..."
                                                    : "Get the Vegas Guide"}
                                            </button>
                                            <div className="mt-1 flex flex-wrap items-center justify-center gap-x-2 text-sm text-gray-400">
                                                <span>PDF · $14.99</span>
                                                <button type="button" onClick={() => setShowGuidePromo((visible) => !visible)} className="font-semibold text-gray-300 underline underline-offset-2 hover:text-white">
                                                    Enter promo code
                                                </button>
                                            </div>
                                            {showGuidePromo && (
                                                <div className="mt-3 w-full">
                                                    <div className="flex gap-2">
                                                        <input type="text" value={guidePromoCode} onChange={updateGuidePromoCode} placeholder="Enter promo code" maxLength="20" className="min-w-0 flex-1 rounded-md border border-white/30 bg-white px-3 py-2 uppercase text-gray-900" />
                                                        <button type="button" onClick={applyGuidePromoCode} disabled={guidePromoStatus === "checking" || guideCheckoutStatus === "loading"} className="rounded-md bg-[#b42520] px-4 py-2 font-semibold text-white hover:bg-[#941c18] disabled:opacity-60">
                                                            {guidePromoStatus === "checking" ? "Checking..." : "Apply"}
                                                        </button>
                                                    </div>
                                                    {guidePromoMessage && <p className={`mt-2 text-center text-sm font-semibold ${guidePromoStatus === "error" ? "text-red-300" : "text-green-300"}`} role="status">{guidePromoMessage}</p>}
                                                </div>
                                            )}
                                            {guideCheckoutError && (
                                                <p className="mt-2 text-sm text-red-300 text-center" role="alert">
                                                    {guideCheckoutError}
                                                </p>
                                            )}
                                        </div>

                                        <ul className="mt-4 space-y-3 text-white text-base list-disc pl-5">
                                            <li>
                                                The Ultimate Vegas Guide starts here, 114 pages packed with insider recommendations, hidden gems, and can't miss classics.
                                            </li>
                                            <li>
                                                Learn how to save money, score upgrades, and navigate the Strip like a professional.
                                            </li>
                                            <li>
                                                Keep it on your phone or print it out and reference it anytime.
                                            </li>
                                        </ul>
                                    </div>

                                    <Link
                                        to="/jackpot-vip"
                                        className="flex h-full flex-col rounded-xl bg-white/10 border border-white/20 p-5 shadow-md transition
               hover:border-[#b42520] hover:bg-white/15 hover:shadow-xl focus:outline-none focus:ring-2 focus:ring-[#b42520]"
                                        aria-label="Jackpot VIP Las Vegas Trip Planning"
                                    >
                                        <div className="text-sm font-extrabold text-[#ff3b30]">
                                            JACKPOT VIP
                                        </div>

                                        <div className="mt-2 text-2xl font-extrabold lg:min-h-[4.5rem]">
                                            Want Vegas planned for you, start to finish?
                                        </div>

                                        <div className="mt-4 flex flex-col items-center">
                                            <Link
                                                to="/request-quote"
                                                className="inline-flex min-h-[52px] w-full items-center justify-center rounded-lg bg-[#b42520] px-5 py-3 text-lg font-extrabold text-white transition hover:bg-[#941c18]"
                                            >
                                                Request a Quote
                                            </Link>
                                            <div className="mt-1 text-sm text-gray-400">
                                                Free Consultation
                                            </div>
                                        </div>

                                        <ul className="mt-4 space-y-1 text-white text-base list-disc pl-5">
                                            <li>
                                                Not sure where to start? Get matched with an expert Las Vegas concierge who will build your trip around what you actually want to do.
                                            </li>

                                            <li>
                                                We'll tap our exclusive partnerships to score you discounts on hotels, nightlife, and more, plus VIP perks you won't find on your own.
                                            </li>

                                            <li>
                                                Once your itinerary is set, we'll book it all for you and stay on call for concierge support the entire time you're in town.
                                            </li>
                                        </ul>

                                        <div className="mt-4 text-center">
                                            <span className="text-[#ff3b30] underline underline-offset-4 font-bold">
                                                See a sample itinerary -&gt;
                                            </span>
                                        </div>
                                    </Link>

                                    <div
                                        className="flex h-full flex-col rounded-xl bg-white/10 border border-white/20 p-5 shadow-md transition
                                                   hover:border-[#b42520] hover:bg-white/15 hover:shadow-xl"
                                        aria-label="Same-day concierge support in Las Vegas"
                                    >
                                        <div className="text-sm font-extrabold text-[#ff3b30]">
                                            SAME-DAY SUPPORT
                                        </div>

                                        <div className="mt-2 text-2xl font-extrabold lg:min-h-[4.5rem]">
                                            Already in Vegas and want an expert on call?
                                        </div>

                                        <div className="mt-4 flex flex-col items-center">
                                            <Link
                                                to="/concierge-service"
                                                className="inline-flex min-h-[52px] w-full items-center justify-center rounded-lg bg-[#b42520] px-5 py-3 text-lg font-extrabold text-white transition hover:bg-[#941c18]"
                                            >
                                                Book Concierge Support
                                            </Link>
                                            <div className="mt-1 text-sm text-gray-400">
                                                Unlimited Support · $49.99
                                            </div>
                                        </div>

                                        <ul className="mt-4 space-y-3 text-white text-base list-disc pl-5">
                                            <li>
                                                Skip the guesswork and skip the AI bots. Book a real Las Vegas concierge and get answers in minutes.
                                            </li>
                                            <li>
                                                We'll recommend the best experiences in Las Vegas and tap our partnerships to score you discounts and VIP perks whenever we can.
                                            </li>
                                            <li>
                                                Stay connected with our concierge team throughout your visit for real time support and local expertise.
                                            </li>
                                        </ul>

                                        <div className="mt-6">
                                            <Link
                                                to="/concierge-service"
                                                className="font-bold text-[#ff3b30] underline underline-offset-4"
                                            >
                                                Also available through the Jackpot Concierge app →
                                            </Link>
                                        </div>
                                    </div>
                                </div>

                                <div className="mt-4">
                                    <Link
                                        to="/faq"
                                        className="text-sm font-bold text-gray-200 hover:text-white underline underline-offset-4"
                                    >
                                        Learn More (FAQ)
                                    </Link>
                                </div>
                            </div>
                        </main>
                    </div>

                    <div className="flex justify-center px-6 mt-10">
                        <div
                            className="w-full max-w-5xl bg-white bg-opacity-0 text-white rounded-lg p-6 shadow-md"
                            style={{
                                fontFamily:
                                    "'oswald', sans-serif",
                            }}
                        >
                            <h3 className="text-center text-2xl font-bold mb-4">
                                The Service Vegas Should Be Known For
                            </h3>

                            <p className="mx-auto mb-4 max-w-4xl text-center">
                                Most Vegas spots care more about upselling than upgrading your trip. From $25 bottles of water to the endless wait just to get fresh towels, top tier service can feel like a thing of the past. And when the answer is &quot;just ask Al,&quot; you're trading one impersonal experience for another, this trip is too important for that. That's where the professionals come in. The Jackpot Concierge team of local experts is here to give you insider tips, personalized recommendations, and great deals. You get VIP-level service without the VIP price tag.
                            </p>

                            <p className="text-center text-sm text-gray-400">
                                Hotels - Dining • Nightlife • Day Clubs • Live Entertainment • Shows • Golf &amp; more
                            </p>

                            <div className="mt-6">
                                <img
                                    src={
                                        ConciergeSignal
                                    }
                                    alt="ConciergeSignal"
                                    className="w-full max-w-3xl mx-auto rounded-lg border border-white"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Home;
